<template>
  <div>
    <header
      class="header-menu">
      <router-link
        v-for="item in menus"
        class="menu-item"
        tag="div"
        :class="{ active: activeMenuItem(item) }"
        :key="item.link"
        :to="item.link">
        <div
          class="title"
          v-if="item.type != 'icon'">
          {{ item.title }}
        </div>
        <div
          class="title"
          v-else>
          <i
            class="icon n-i"
            :class="item.icon" />
        </div>
        <div class="subtitle">{{ item.subtitle }}</div>
      </router-link>

      <div v-if="showHours">
        <router-link
          v-for="item in hours"
          class="hour-wrapper"
          tag="div"
          :class="{ active: activeMenuItem(item) }"
          :key="item.id"
          :to="{
            name: 'Offer',
            params: {
              dateFrom: item.startTime,
              dateTo: item.endTime,
              timeSpan: item.timeSpan,
              id: item.id,
            }
        }">
          <div class="hour">
            {{ item.title }}
          </div>
        </router-link>
      </div>

      <div
        class="toggle-betslip"
        @click="toggleBetslip()"
      >
        <div class="betslip-header-wrapper">
          <span class="betslip-header-title">
            <i class="n-i n-i-betslip"/>
            {{ betslipTitle }}
            <span>({{ betslip.bets.length }})</span>
          </span>
          {{ betslip.totalOdds }}
          <span
            class="betlip-header-stake"
          >{{ betslip.stake.toFixed(2) }}</span>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import Moment from 'moment';
import Helpers from '../../../services/helpers';

export default {
  props: {
    showHours: {
      type: Boolean,
      required: true,
      default: false,
    },
    regenerateLinks: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      menus: [],
      hours: [],
    };
  },
  computed: {
    betslip() {
      return this.$store.getters.getBetslip;
    },
    betslipTitle() {
      return this.$store.getters.getTranslation('betslip.header_title');
    },
    company() {
      return this.$store.getters.getCompany;
    },
    topEventsTitle() {
      return this.$store.getters.getTranslation('sportsbook.top_events');
    },
  },
  methods: {
    toggleBetslip() {
      this.$store.dispatch('toggleBetslip');
    },
    regenerateHeaderLinks() {
      const days = Helpers.generateDays();

      const menu = [
        {
          link: '/',
          title: this.topEventsTitle,
          type: 'icon',
          icon: 'n-i-star',
          subtitle: this.topEventsTitle,
        },
      ];

      days.forEach((element) => {
        menu.push({
          link: `/offer/${element.startTime}/${element.endTime}/${element.id}`,
          title: new Moment(element.startTime).locale(this.company.locale).format('ddd'),
          type: 'text',
          id: element.id,
          subtitle: new Moment(element.startTime).format('D.M.'),
        });
      });

      this.menus = menu;
      this.hours = Helpers.generateHours();
    },
    activeMenuItem(item) {
      if (this.$route.name === 'Outrights' || this.$route.name === 'OutrightsTournament') {
        return false;
      }
      const hoursIds = [1, 2, 3, 4];
      const todayId = 100;
      const routeId = parseInt(this.$route.params.id, 10);

      const hourSelected = hoursIds.indexOf(routeId) !== -1;

      // Fix for today
      // If time filter is selected, today should be also selected
      if (hourSelected && todayId === item.id) {
        return true;
      }

      return (routeId === item.id) || (!routeId && !item.id);
    },
  },
  beforeMount() {
    this.regenerateHeaderLinks();
  },
  watch: {
    regenerateLinks(newValue) {
      if (newValue) {
        this.regenerateHeaderLinks();
      }
    },
  },
};
</script>
<style lang="scss">
  @import '../../../scss/default/icons';
  .header-menu {
    font-weight: 400;
    font-size: 26px;
    height: 70px;
    background: #242424;

    .menu-item {
      display: block;
      height: 100%;
      width: 2/24*100%;
      float: left;
      text-decoration: none;
      background: #242424;
      text-align: center;
      border-right: 1px solid rgba(0, 0, 0, 0.3);
      font-size: 16px;

      .title {
        height: 50%;
        line-height: 50px;
        color: #fff;
        text-transform: uppercase
      }

      .subtitle {
        height: 50%;
        color: rgba(255, 255, 255, 0.5);
        font-size: 14px;
      }

      &.active {
        background: #404040;
      }
    }

    .hour-wrapper {
      display: block;
      float: left;
      width: 1/24*100%;
      height: 100%;
      line-height: 36px;
      text-decoration: none;
      font-size: 14px;
      text-align: center;
      color: #fff;
      margin: 16px 0 0 15px;

      .hour {
        width: 40px;
        height: 40px;
        border: 2px solid #3c3b3c;
        border-radius: 50%;
      }

      &.active {
        .hour {
          color: #0066ae;
          border-color: #0066ae;
        }
      }
    }

    .toggle-betslip {
      display: flex;
      align-items: center;
      float: right;
      width: 3/24*100%;
      height: 100%;
      background: #ffb300;
      color: #000;
      padding: 10px;
      font-size: 16px;
    }

    .betslip-header-wrapper {
      width: 100%;
    }

    .betslip-header-title {
      display: block;
      width: 100%;
      margin-bottom: 2px;
    }

    .betlip-header-stake {
      background: #cf9100;
      display: block;
      width: 100%;
      color: #fff;
      padding: 2px 5px;
    }

    @media all and (min-width: 1201px) {
      .toggle-betslip {
        display: none;
      }
    }

    @media all and (max-width: 1200px) {
      .menu-item {
        width: 80px;
      }
    }
  }
</style>
